import { render, staticRenderFns } from "./WorkCalendarTaskAssignmentInfo.vue?vue&type=template&id=410a745a&scoped=true"
import script from "./WorkCalendarTaskAssignmentInfo.vue?vue&type=script&lang=js"
export * from "./WorkCalendarTaskAssignmentInfo.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarTaskAssignmentInfo.vue?vue&type=style&index=0&id=410a745a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410a745a",
  null
  
)

export default component.exports